export const EditBgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="69"
    fill="none"
    viewBox="0 0 69 69"
    {...props}>
    <rect
      width="60"
      height="60"
      x="4.898"
      y="4.617"
      fill="#DEF3FF"
      rx="28"></rect>
    <rect
      width="60"
      height="60"
      x="4.898"
      y="4.617"
      stroke="#F1FAFF"
      strokeWidth="8"
      rx="28"></rect>
    <path
      stroke="#0071BC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M36.474 24.117L26.21 34.98c-.387.412-.762 1.225-.837 1.787l-.463 4.05c-.162 1.463.888 2.463 2.338 2.213l4.025-.688c.562-.1 1.35-.512 1.737-.937l10.263-10.863c1.775-1.875 2.575-4.012-.188-6.625-2.75-2.587-4.837-1.675-6.612.2zM34.762 25.93a7.658 7.658 0 006.812 6.437M23.648 47.117h22.5"></path>
  </svg>
);
